package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.runtime.Composable

@Composable
actual fun PlatformStatusBarAppearance(lightIcons: Boolean) {
    // No status bar on web.
}
